/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Block } from './Block';
import type { CasesSlide } from './CasesSlide';
import type { SimplePatient } from './SimplePatient';
import type { Specimen } from './Specimen';
import type { UserContact } from './UserContact';
import type { UserName } from './UserName';

export type Cases = {
    readonly id?: number;
    patient: SimplePatient;
    /**
     * Changing this value will NOT modify the collected_date for each specimen.
     */
    collected_date?: string | null;
    readonly collected_date_offset?: string;
    readonly collected_date_timezone?: string;
    readonly created_at?: string;
    readonly updated_at?: string;
    /**
     * The Accession Number of the Case
     */
    readonly accession?: string | null;
    /**
     * A secondary or external accession for the same case from the system that provided the data to WPL, e.g. Poplar, RPA.
     */
    external_accession?: string | null;
    ordering_doctor: UserContact;
    supervising_physician: UserContact;
    /**
     * date/time that we received a WPL order message indicating grossing was completed. This will match the order_message FK.
     */
    gross_completed?: string | null;
    /**
     * date/time that we received a WPL order message indicating accessioning was completed
     */
    accession_completed?: string | null;
    priority?: Cases.priority;
    readonly slides?: Array<CasesSlide>;
    blocks: Array<Block>;
    /**
     * current workflow status of the case
     */
    status?: Cases.status;
    active_assignment: UserName;
    readonly screen_assignment_id?: number;
    readonly finalize_assignment_id?: number;
    is_screening?: boolean;
    is_request_screen_complete?: boolean;
    is_manually_accessioned?: boolean | null;
    specimens: Array<Specimen>;
    readonly high_res_removal_date?: string;
    readonly finalized_report_id?: number;
    readonly prelim_report_id?: number;
    working_reasons: any;
    /**
     * Changing this value will NOT modify the received_date for each specimen.
     */
    received_date?: string | null;
    readonly received_date_offset?: string;
    readonly received_date_timezone?: string;
    /**
     * case origin, WPL or PW LIS
     */
    source?: Cases.source;
    /**
     * Order id get from order message from third party, e.g. ModMed
     */
    external_order_id?: string | null;
    /**
     * EZDerm's order id that, with patient name, matches the case in their system
     */
    external_ezderm_order_id?: string | null;
    type?: Cases.type;
    /**
     * date/time case was first signed out
     */
    finalized_at?: string | null;
}

export namespace Cases {

    export enum priority {
        RUSH = 'rush',
        STAT = 'stat',
        NORMAL = 'normal',
    }

    /**
     * current workflow status of the case
     */
    export enum status {
        ORDERED = 'ordered',
        ACTIVE = 'active',
        WORKING = 'working',
        FLAGGED = 'flagged',
        FINALIZED = 'finalized',
        DELETED = 'deleted',
        ARCHIVED = 'archived',
        LIS_PENDING = 'lis-pending',
        ERROR = 'error',
    }

    /**
     * case origin, WPL or PW LIS
     */
    export enum source {
        WPL = 'wpl',
        PW = 'pw',
        APL = 'apl',
    }

    export enum type {
        CLINICAL = 'clinical',
        TEST = 'test',
        DEMO = 'demo',
        VALIDATION = 'validation',
        CONSULT = 'consult',
        CONTROL = 'control',
        TC_PC = 'tc-pc',
        HISTORICAL = 'historical',
    }


}
